module.exports = " <h6>Ihr Browser ist veraltet!</h6> <p>Bitte aktualisieren Sie Ihren Browser, um diese Website korrekt dazustellen. <a id=btnUpdateBrowser href=http://outdatedbrowser.com/de>Den Browser jetzt aktualisieren </a></p> <p class=last><a href=# id=btnCloseUpdateBrowser title=Schließen>&times;</a></p> ";


//////////////////
// WEBPACK FOOTER
// ./outdated-browser/lang/de.html
// module id = 822
// module chunks = 2